import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React, { useRef, useContext } from 'react';
import AdvertisingContext from '../AdvertisingContext';
import calculateRootMargin from './utils/calculateRootMargin';
import isLazyLoading from './utils/isLazyLoading';
import getLazyLoadConfig from './utils/getLazyLoadConfig';
import { useIsomorphicLayoutEffect } from '../hooks/useIsomorphicLayoutEffect';

function AdvertisingSlot(_ref) {
  var id = _ref.id,
      style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      customEventHandlers = _ref.customEventHandlers,
      restProps = _objectWithoutProperties(_ref, ["id", "style", "className", "children", "customEventHandlers"]);

  var observerRef = useRef(null);
  var containerDivRef = useRef();

  var _useContext = useContext(AdvertisingContext),
      activate = _useContext.activate,
      config = _useContext.config;

  var lazyLoadConfig = getLazyLoadConfig(config, id);
  var isLazyLoadEnabled = isLazyLoading(lazyLoadConfig);
  useIsomorphicLayoutEffect(function () {
    if (!config || !isLazyLoadEnabled) {
      return function () {};
    }

    var rootMargin = calculateRootMargin(lazyLoadConfig);
    observerRef.current = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          isIntersecting = _ref3[0].isIntersecting;

      if (isIntersecting) {
        activate(id, customEventHandlers);

        if (containerDivRef.current) {
          observerRef.current.unobserve(containerDivRef.current);
        }
      }
    }, {
      rootMargin: rootMargin
    });
    observerRef.current.observe(containerDivRef.current);
    return function () {
      if (containerDivRef.current) {
        observerRef.current.unobserve(containerDivRef.current);
      }
    };
  }, [activate, config]);
  useIsomorphicLayoutEffect(function () {
    if (!config || isLazyLoadEnabled) {
      return;
    }

    activate(id, customEventHandlers);
  }, [activate, config]);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    style: style,
    className: className,
    children: children,
    ref: containerDivRef
  }, restProps));
}

AdvertisingSlot.propTypes = {
  id: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  customEventHandlers: PropTypes.objectOf(PropTypes.func).isRequired
};
AdvertisingSlot.defaultProps = {
  customEventHandlers: {}
};
export default AdvertisingSlot;